export const SESSIONLESS_ROUTE_PREFIXES = ['/sign-sst-request'] as const;

export const isSessionlessRoute = (pathname: string): boolean => {
  return SESSIONLESS_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};
